export default __webpack_public_path__ + "static/media/self-service.9347ffe3.png";